import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Home, Search, ArrowLeft, Send } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Seo from "../components/Seo";

const POPULAR_CATS = [
  { key: "star-wars", label: "Star Wars" },
  { key: "technic", label: "Technic" },
  { key: "icons", label: "Icons" },
  { key: "creator", label: "Creator" },
  { key: "city", label: "City" },
  { key: "harry-potter", label: "Harry Potter" },
];

export default function NotFound() {
  const navigate = useNavigate();
  const [q, setQ] = React.useState("");

  const onSearch = (e) => {
    e.preventDefault();
    const s = q.trim();
    if (s) navigate(`/?q=${encodeURIComponent(s)}`);
  };

  return (
    <div className="min-h-screen bg-[var(--bdd-bg)]" data-testid="page-404">
      <Seo
        title="Pagina non trovata (404)"
        description="La pagina che stai cercando non esiste o è stata rimossa. Sfoglia le ultime offerte BrickDailyDeals."
        path="/404"
        noindex={true}
      />
      <Header />

      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
        <div className="font-mono-bdd text-xs uppercase tracking-[0.3em] text-[#FBD51C] mb-3">
          Errore 404
        </div>
        <h1 className="font-display font-black text-4xl sm:text-5xl text-white tracking-tight mb-4">
          Pagina non trovata
        </h1>
        <p className="text-zinc-400 text-lg mb-10 max-w-xl mx-auto">
          La pagina che stai cercando non esiste, è stata rimossa oppure l&apos;offerta
          è scaduta. Niente paura — abbiamo decine di alternative qui sotto.
        </p>

        <form onSubmit={onSearch} className="max-w-md mx-auto mb-10">
          <div className="flex items-center gap-2 bg-zinc-900 border border-zinc-800 rounded-full pl-5 pr-1 py-1">
            <Search size={16} className="text-zinc-500" />
            <input
              autoFocus
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Cerca un set..."
              className="bg-transparent outline-none text-sm text-white placeholder:text-zinc-500 flex-1 py-2.5"
            />
            <button
              type="submit"
              className="bg-[#FBD51C] hover:bg-[#FFE552] text-black text-xs font-black uppercase tracking-wider rounded-full px-4 py-2"
            >
              Cerca
            </button>
          </div>
        </form>

        <div className="mb-10">
          <div className="text-xs font-mono-bdd uppercase tracking-wider text-zinc-500 mb-4">
            Categorie più cercate
          </div>
          <div className="flex flex-wrap gap-2 justify-center">
            {POPULAR_CATS.map((c) => (
              <Link
                key={c.key}
                to={`/categoria/${c.key}`}
                className="inline-flex items-center gap-2 bg-zinc-900 hover:bg-zinc-800 border border-zinc-800 hover:border-[#FBD51C]/40 text-white text-sm font-bold px-4 py-2 rounded-full transition-colors"
              >
                {c.label}
              </Link>
            ))}
          </div>
        </div>

        <div className="flex flex-wrap gap-3 justify-center">
          <Link
            to="/"
            data-testid="404-home"
            className="inline-flex items-center gap-2 bg-[#FBD51C] hover:bg-[#FFE552] text-black font-black uppercase tracking-wider text-xs px-6 py-3 rounded-full"
          >
            <Home size={14} /> Torna alla home
          </Link>
          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center gap-2 bg-zinc-900 hover:bg-zinc-800 text-white border border-zinc-800 text-sm font-bold px-5 py-3 rounded-full"
          >
            <ArrowLeft size={14} /> Pagina precedente
          </button>
          <a
            href="https://t.me/BrickDailyDeals"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#229ED9] hover:bg-[#1c8acb] text-white text-sm font-bold px-5 py-3 rounded-full"
          >
            <Send size={14} /> Canale Telegram
          </a>
        </div>
      </main>

      <Footer />
    </div>
  );
}
